<template>
	<div class="p-col-12 p-grid">
		<div v-if="!commonService.isMobile()" class="p-col-12 p-lg-6" style="margin: auto">
			<div class="card card-w-title" style="width: 100%;">
				<Toast />
				<div class="p-grid">
					<img :src="commonService.getHomeReportingImageUrl()" alt="" style="width: 100%">
				</div>
			</div>
		</div>

		<div class="p-col-12 p-lg-6" :class="[commonService.isMobile() ? 'text-box-mobile' : 'text-box']">
			<p>For the Clubs</p>
			<p class="login-subtitle">Reporting</p>
			<p v-if="!commonService.isMobile()" class="login-text justified">Our platform provides comprehensive data and verified information on players, including their abilities, performance history, and potential growth projections. Our algorithm generates recommendations for players to analyze and negotiate with, while the community of experienced coaches, team presidents, and directors confirms the accuracy of each player's skills.</p>
			<p v-if="!commonService.isMobile()" class="login-text justified">By using our reliable insights, you can make informed decisions during the transfer market, reducing the risk of selecting the wrong player and increasing your team's chances of success.</p>
			<p v-if="commonService.isMobile()" class="login-text justified">Discover comprehensive player data, including abilities, performance history, and growth projections, on our platform.</p>
			<p v-if="commonService.isMobile()" class="login-text justified">Our algorithm generates personalized recommendations, while experienced coaches and team leaders confirm player skills.</p>
			<p v-if="commonService.isMobile()" class="login-text justified">Make informed decisions during the transfer market and increase your team's success with our reliable insights.</p>
			<div v-if="!commonService.isMobile()" class="p-lg-2 button-box" >
				<Button label="Try now" class="p-button-warning" style="color: white; font-weight: bold;" @click="toLogin" />
			</div>
		</div>
		<div v-if="commonService.isMobile()" class="p-col-12 p-lg-6" style="margin: auto">
			<div class="card card-w-title" style="width: 100%;">
				<Toast />
				<div class="p-grid">
					<img :src="commonService.getHomeReportingImageUrl()" alt="" style="width: 100%">
				</div>
			</div>
			<div v-if="commonService.isMobile()" class="p-col-4 button-box-mobile" style="margin-top: -10px; margin-bottom: 30px">
				<Button label="Try now" class="p-button-warning" style="color: white; font-weight: bold;" @click="toLogin" />
			</div>
		</div>
	</div>

</template>

<script>
import CommonService from "@/service/CommonService";

export default {
	commonService: null,
	created() {
		this.commonService = new CommonService();
	},
	methods: {
		toLogin() {
			this.$router.push("/login");
		},
	},
};
</script>

<style scoped>
.justified {
	text-align: justify;
	text-justify: inter-word;
}

.login-title {
	margin-top: -15px;
	font-size: 65px;
	font-weight: bold;
}

.login-subtitle {
	margin-top: -10px;
	font-size: xx-large;
	font-weight: bold;
}

.login-text {
	margin-top: 10px;
	font-size: 19px;
}

.text-box {
	margin: auto;
	padding-left: 50px;
}

.text-box-mobile {
	margin: auto;
}

.button-box {
	margin-top: 20px;
}

.button-box-mobile {
	margin: auto;
}

@media (min-width: 0px) and (max-width: 1000px) {
	.login-title {
		margin-top: -15px;
		font-size: 45px;
		font-weight: bold;
	}

	.login-subtitle {
		margin-top: -0px;
		font-size: x-large;
		font-weight: bold;
    }

	.login-text {
		margin-top: 10px;
		font-size: 16px;
	}
}
</style>